/** @format */

import { NgModule } from '@angular/core';
import {
  HomefieldIconLibraryModule,
  HomefieldIconsLibraryService,
  homefieldIconStarFill,
} from '@dsg-tech/homefield-angular-icons';

import { CommonModule } from '@angular/common';
import { HomefieldProductBadgeComponent } from './product-badge.component';

@NgModule({
  imports: [CommonModule, HomefieldIconLibraryModule],
  declarations: [HomefieldProductBadgeComponent],
  exports: [HomefieldProductBadgeComponent],
})
export class HomefieldProductBadgeModule {
  constructor(HomefieldIconsLibraryService: HomefieldIconsLibraryService) {
    HomefieldIconsLibraryService.registerIcons([homefieldIconStarFill]);
  }
}
